import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Skeleton } from '@usepepper/sprout-kit-ui';
import { View, ViewStyle } from 'react-native';

const SKELETON_ROW_COUNT = 6;
const IMG_SIZE = 80;
const TEXT_BLOCK_HEIGHT = 12;
const TITLE_WIDTH = '60%';
const ADDRESS_WIDTH = '60%';
const META_WIDTH = '50%';

const getRowFadeStyle = (index: number): ViewStyle => ({
  opacity: 1 - index * 0.15,
});

export const ProspectsListSkeleton: React.FC = () => {
  const [styles, theme] = useStyles();

  return (
    <View
      accessibilityLabel={i18n.t(
        'sales_portal.prospect_finder.results.loading',
      )}
      accessibilityRole="progressbar"
      accessibilityState={{ busy: true }}
      style={styles.container}
    >
      {Array.from({ length: SKELETON_ROW_COUNT }).map((_, idx) => (
        <View key={idx} style={[styles.row, getRowFadeStyle(idx)]}>
          <Skeleton
            borderRadius={theme.sk.radii.radiusSmall}
            height={IMG_SIZE}
            loadingLabel=""
            width={IMG_SIZE}
          />
          <View style={styles.content}>
            <Skeleton
              borderRadius={theme.sk.radii.radiusMedium}
              height={TEXT_BLOCK_HEIGHT}
              loadingLabel=""
              width={TITLE_WIDTH}
            />
            <Skeleton
              borderRadius={theme.sk.radii.radiusMedium}
              height={TEXT_BLOCK_HEIGHT}
              loadingLabel=""
              width={ADDRESS_WIDTH}
            />
            <Skeleton
              borderRadius={theme.sk.radii.radiusMedium}
              height={TEXT_BLOCK_HEIGHT}
              loadingLabel=""
              width={META_WIDTH}
            />
          </View>
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    gap: theme.sk.spacing.spaceXsmall,
    justifyContent: 'center',
  },
  row: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceMedium,
    paddingHorizontal: theme.sk.spacing.spaceMedium,
    paddingVertical: theme.sk.spacing.spaceMedium,
  },
}));
